import { formatPrice } from '@/components/EcocreditsMonthlyMadness/utils';
import { getListProducts } from '@/service/vip';
import * as React from 'react';

import type { IProductItem, ProductModule } from '@/components/EcocreditsMonthlyMadness/type';

const { useState, useEffect } = React;

const SAVE_SITES = ['eu', 'uk', 'de', 'fr', 'es', 'it'];

export const useProductList = (module: ProductModule, locale: string) => {
    const [loading, setLoading] = useState(true);
    const [productList, setProductList] = useState<IProductItem[]>([]);

    useEffect(() => {
        getListProducts(
            {
                module,
            },
            locale,
        )
            .then((res) => {
                if (!res || res.code !== '0') return;
                const data = res.data?.map((item: IProductItem) => {
                    const newItem = { ...item };

                    if (parseInt(newItem.compareAtPrice) > parseInt(newItem.memberPrice)) {
                        newItem.discount = formatPrice(String(parseInt(newItem.compareAtPrice) - parseInt(newItem.memberPrice)), locale);
                    }

                    newItem.memberPrice2 = formatPrice(newItem.memberPrice, locale);
                    newItem.compareAtPrice2 = newItem.compareAtPrice ? formatPrice(newItem.compareAtPrice, locale) : '';
                    return newItem;
                });

                setProductList(data);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    return { productList, loading };
};
